module.exports = {
  title: '用户子账号详情',
  route: {
    path: 'user-manage',
    children: {
      path: 'user-subaccount-detail',
    },
  },
};
